<script setup lang="ts">
import { Color } from '@previo/codebooks'
import PBtn from '../../btn/PBtn.vue'
import { PBtnType } from '../../btn/types'
import PSpace from '../../space/PSpace.vue'
import { PSpaceSize } from '../../space/types'
import PTextStandard from '../../typography/body/PTextStandard.vue'

type Props = {
  isFirstPage: boolean
  isLastPage: boolean
  statusText: string
  disabled: boolean
}

defineProps<Props>()

type Emits = {
  (e: 'prev', evt: Event): void
  (e: 'next', evt: Event): void
}

const emits = defineEmits<Emits>()

const onClickPrev = (e: Event) => {
  emits('prev', e)
}

const onClickNext = (e: Event) => {
  emits('next', e)
}
</script>

<template>
  <div class="p-flex p-flex-1 p-justify-center">
    <p-space :mobile="PSpaceSize.XS" vertical />

    <div class="p-flex p-items-center p-full-width p-justify-between">
      <p-btn
        cy="page-prev"
        :color="Color.PRIMARY"
        :type="PBtnType.TERTIARY"
        :disable="disabled || isFirstPage"
        icon-end="chevron-left"
        @click="onClickPrev"
      />

      <p-text-standard :text="statusText" :color="Color.GREY_500" />

      <p-btn
        cy="page-next"
        :color="Color.PRIMARY"
        :type="PBtnType.TERTIARY"
        :disable="disabled || isLastPage"
        icon-end="chevron-right"
        @click="onClickNext"
      />
    </div>

    <p-space :mobile="PSpaceSize.XS" vertical />
  </div>
</template>
